import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { IoMdCheckmarkCircle } from "react-icons/io";

import logo from '../../../assets/sobhaReality/logo.png'


import heroImg1 from '../../../assets/sobhaReality/mainFeed-1.jpg'
import heroImg2 from '../../../assets/sobhaReality/mainFeed-2.jpg'
import heroImg3 from '../../../assets/sobhaReality/mainFeed-3.jpg'
import heroImg4 from '../../../assets/sobhaReality/mainFeed-4.jpg'
import heroImg5 from '../../../assets/sobhaReality/mainFeed-5.jpg'
import heroImg6 from '../../../assets/sobhaReality/mainFeed-6.jpg'


import ameneties1 from '../../../assets/sobhaReality/ameneties-1.jpg'
import ameneties2 from '../../../assets/sobhaReality/ameneties-2.jpg'
import ameneties3 from '../../../assets/sobhaReality/ameneties-3.jpg'
import ameneties4 from '../../../assets/sobhaReality/ameneties-4.webp'
import ameneties5 from '../../../assets/sobhaReality/ameneties-5.jpg'

import interior1 from '../../../assets/sobhaReality/interior-1.jpg'
import interior2 from '../../../assets/sobhaReality/interior-2.jpg'
import interior3 from '../../../assets/sobhaReality/interior-3.jpg'
import interior4 from '../../../assets/sobhaReality/interior-4.jpg'
import interior5 from '../../../assets/sobhaReality/interior-5.webp'


import { ImageModal } from '../../common/ImageModal';
import { ConnectForm } from '../../common/ConnectForm';
import ImageSwiper from '../../common/ImageSwiper';


const SobhaReality = () => {
  const location = useLocation();
  const [openImgModal, setOpenImgModal] = useState(false);

  const [selectedImgIndex, setSelectedImgIndex] = useState(null);
  const [activeImageType, setActiveImageType] = useState(null);

  const images = [heroImg1, heroImg2, heroImg3, heroImg4, heroImg5, heroImg6];
  const interiors = [interior1, interior2, interior3, interior4, interior5]
  const ameneties = [ameneties1, ameneties2, ameneties3, ameneties4, ameneties5]


  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);


  const handleOpenModal = (index, type) => {
    setSelectedImgIndex(index);
    setActiveImageType(type);
    setOpenImgModal(true);
  }

  return (
    <div className="w-full min-h-screen bg-gray-100">
      <ImageSwiper images={images} />

      <div className="w-full p-2 flex justify-center items-center overflow-hidden transition-all duration-500">
        <div className="w-[90%] sm:w-[80%] md:w-[70%] lg:w-[60%] xl:w-[50%] max-h-[300px]">
          <img src={logo} alt="logo" className="w-full h-full object-contain rounded-lg" />
        </div>
      </div>

      <div class="flex flex-col md:flex-row px-2.5 gap-4">
        <div class="w-full md:w-2/3 flex flex-col gap-4">
          <div className="">
            <div className="max-w-5xl mx-auto p-6">
              <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                Sobha Realty has recently announced an exciting new residential project in <strong>Sector 36, Greater
                  Noida</strong>, which is set to redefine luxury living. This development offers a range of <strong>2, 3, and 4 BHK
                    premium apartments</strong>, designed to cater to modern lifestyles with a perfect blend of comfort,
                convenience, and elegance.
              </p>
              <h2 className="text-2xl md:text-3xl font-bold my-2">Key Features:</h2>
              <section className="p-4 md:p-6 bg-gray-100 text-gray-900 rounded-lg">
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Prime Location:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    Situated in Sector 36, the project enjoys excellent connectivity to major
                    highways like the Noida-Greater Noida Expressway, Yamuna Expressway, and Eastern Peripheral
                    Expressway. It is also close to metro stations, ensuring seamless travel across the Delhi-NCR region.
                  </p>
                </div>
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Green Living:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    Approximately **80% of the area is dedicated to open green spaces**,
                    promoting a sustainable and serene lifestyle.
                  </p>
                </div>
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Modern Amenities:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    The project boasts a host of world-class facilities, including a clubhouse,
                    swimming pool, fitness center, landscaped gardens, children's play areas, and more.
                  </p>
                </div>
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Eco-Friendly Design:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    Sobha Realty emphasizes sustainability by using eco-friendly
                    construction materials and energy-efficient technologies, reducing the carbon footprint.
                  </p>
                </div>
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Spacious Apartments:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    The apartments are thoughtfully designed with optimal natural light,
                    ventilation, and efficient space utilization, making them ideal for families and individuals alike.
                  </p>
                </div>
              </section>


              <h2 className="text-2xl md:text-3xl font-bold my-4">Additional Details:</h2>
              <ul className="space-y-1 text-left max-w-2xl my-2 font-medium">
                <li className="flex items-start">
                  <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                  The project spans 3.5 acres and features two high-rise towers with 31 floors each.
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                  Unit sizes start at 1,200 sq. ft. for 2 BHK apartments, with larger configurations available.
                </li>
                <li className="flex items-start">
                  <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                  The development is currently in its pre-launch phase, with possession expected in
                  approximately four years.
                </li>
              </ul>

              <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                This project is an excellent opportunity for homebuyers seeking a luxurious and tranquil lifestyle, as
                well as for investors looking for high returns in a thriving real estate market.

                Would you like to explore more about this project or discuss other real estate options?
              </p>
            </div>
          </div>
        </div>
        <ConnectForm />
      </div>
      <div className="max-w-7xl mx-auto p-4">
        <h2 className="text-2xl font-semibold text-gray-800 my-4">
          Projects Highlights
        </h2>
        {openImgModal && activeImageType === "ameneties" && (
          <ImageModal
            images={ameneties}
            openImg={openImgModal}
            selectedImgIndex={selectedImgIndex}
            onClose={() => setOpenImgModal(false)}
          />
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {ameneties.map((data, index) => (
            <div
              key={index}
              onClick={() => handleOpenModal(index, "ameneties")}
              className="w-full mx-auto rounded-md shadow-md overflow-hidden bg-white"
            >
              <img
                src={data}
                alt="ATS"
                className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
              />
            </div>
          ))}
        </div>
      </div>
      <h2 className="text-2xl font-semibold text-gray-800 p-4">
        Luxury  Insights
      </h2>
      {openImgModal && activeImageType === "interiors" && (
        <ImageModal
          images={interiors}
          openImg={openImgModal}
          selectedImgIndex={selectedImgIndex}
          onClose={() => setOpenImgModal(false)}
        />
      )}

      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 p-4">
        {interiors.map((data, index) => (
          <div
            key={index}
            onClick={() => handleOpenModal(index, "interiors")}
            className="w-full mx-auto rounded-md shadow-md overflow-hidden bg-white"
          >
            <img
              src={data}
              alt="ATS"
              className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
            />
          </div>
        ))}
      </div>
    </div>
  )
}
export default SobhaReality